import React from 'react';
import { FormattedMessage } from 'react-intl';

function ErrorTitle({ titleId, titleDefault }: { titleId: string; titleDefault: string }) {
  return <FormattedMessage defaultMessage={titleDefault} id={titleId} tagName='h3' />;
}

export default ErrorTitle;
